<template>
  <base-layout>
    <template #sidebar>
      <ui-settings-sidebar />
    </template>
    <template #breadcrumbs>
      <ui-breadcrumbs
        :breadcrumbs="breadcrumbs"
        :title="title"
      />
    </template>
    <div class="bg-white shadow-sm p-3">
      <div class="mb-3 d-flex justify-content-between">
        <ui-back-button :href="route('settings.dict_types.index')" />
        <ui-delete-button
          v-if="!isNew"
          @delete="deleteClick"
        />
      </div>
      <ui-errors />
      <el-form
        ref="dict_types_form"
        v-loading="form.processing"
        :model="form"
        label-position="top"
        :rules="rules"
        @submit.native.prevent="submit"
      >
        <div class="row">
          <div class="col-12">
            <el-form-item
              label="Имя (для программирования)"
              prop="name"
            >
              <el-input
                id="name"
                v-model="form.name"
                placeholder="по английски snake_case"
                autofocus
                @keyup.enter.native="submit"
              />
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              label="Название (человеческое)"
              prop="title"
            >
              <el-input
                id="title"
                v-model="form.title"
                name="title"
                @keyup.enter.native="submit"
              />
            </el-form-item>
          </div>

          <div class="col-12">
            <el-button
              icon="el-icon-check"
              type="primary"
              @click="submit"
            >
              Сохранить
            </el-button>
          </div>
        </div>
      </el-form>
      {{ dictType }}
    </div>
  </base-layout>
</template>

<script>

import BaseLayout from '@/Layouts/BaseLayout';
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
import UiErrors from '@/components/Ui/UiErrors';
import UiDeleteButton from '@/components/Ui/UiDeleteButton';
import UiSettingsSidebar from '../Ui/UiSettingsSidebar';

export default {
  name: 'DictTypesEdit',
  components: {
    UiSettingsSidebar,
    UiBreadcrumbs,
    BaseLayout,
    UiErrors,
    UiDeleteButton,
  },
  props: {
    dictType: { type: Object, required: true },
    errors: { type: Object, default: () => null },
  },
  data() {
    return {
      breadcrumbs: [
        { title: 'Справочники', href: route('settings.dict_types.index') },
      ],
      form: this.$inertia.form({
        _method: 'post',
        name: this.dictType.name,
        title: this.dictType.title,
      }),
      rules: {
        name: [
          { required: true, message: 'Обязательное поле', trigger: 'blur' },
        ],
        title: [
          { required: true, message: 'Обязательное поле', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    isNew() {
      return !(this.dictType.id);
    },
    title() {
      return this.isNew ? 'Создание записи' : 'Изменение записи';
    },
  },
  methods: {
    deleteClick() {
      this.$inertia.delete(route('settings.dict_types.destroy', this.dictType.id), {
        onSuccess: () => {
          this.$notify.success({
            title: 'Успешно',
            message: 'Удаление было совершено успешно!',
          });
        },
        onError: (errors) => {
          this.$notify.error({
            title: 'Ошибка',
            message: errors.exeption[0],
          });
        },
      });
    },
    validate() {
      return this.$refs.dict_types_form.validate();
    },
    sumbitForm(settings) {
      const url = this.isNew ? route('settings.dict_types.store') : route('settings.dict_types.update', this.dictType.id);
      // Так как PUT метод не поддерживает загрузку файлов
      if (!this.isNew) {
        this.form._method = 'put';
      }
      return this.form.post(url, settings);
    },
    submit() {
      this.validate().then(() => {
        this.sumbitForm({
          onError: () => {
            this.$notify.error({
              title: 'Ошибка сохранения',
              message: 'Исправьте введенные данные',
            });
          },
        });
      }).catch(() => {
        this.$notify.error({
          title: 'Ошибки в форме',
          message: 'Заполните необходимые поля',
        });
      });
    },
  },
};
</script>
